import classNames from "classnames"
import { InsightsEditButtons } from "../Insights"
import { useTabContext } from "../TabContext"
import styles from "./MultiTabHeader.module.scss"
import { TabComponent } from "./TabComponent"
import { Tab } from "src/types"

interface Props {
  className?: string;
}

export function MultiTabHeader(props: Props) {
  const className = classNames(
    styles.container,
    props.className,
  )

  const { currentTab } = useTabContext()

  return (
    <div
      className={className}
      id="multi-tab-header"
    >
      <div className={styles.tabs}>
        <TabComponent
          tab={Tab.Insights}
          id="insights-header"
        />
        <TabComponent
          tab={Tab.Feed}
          id="feed-header"
        />
      </div>
      {currentTab === Tab.Insights && (
        <InsightsEditButtons />
      )}
    </div>
  )
}
